import http from "./HttpService";

const BASE_SERVICE_URL = "points-service";

export default {
  getCustomerBalance(request) {
    return new Promise((resolve, reject) => {
      http
        .get(BASE_SERVICE_URL + "/customer/balance", request.header)
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  }
};
